import { useEffect, useState } from "react";
import { Socket, io } from "socket.io-client";
import { TableName } from "@/src/data/allTypes";
import apiFetch from "./apiFetch";

let socket: Socket<any, any> | null = null;
const socketCallbacks: any = {};

// socket= io(process.env.BACKEND_BASE_URL!);
// console.log("socketoooooooo", socket);

// socket.on("connect", () => {
//   console.log("general socket connect");
// });

// socket.on("disconnect", () => {
//   console.log("general socket disconnect");
// });

// socket.on("error", () => {
//   console.log("general socket error");
// });

// socket.on("connect_error", () => {
//   console.log("general socket connect_error");
// });

// socket.on("tableUpdate", (data: any) => {
//   const { widgetId, tableId, where, action, result } = data;
//   socketCallbacks[widgetId]?.(result);
// });

async function subscribeToTable({
  widgetId,
  tableId,
  includedFields,
  where,
  callback,
}: {
  widgetId: string;
  tableId: string;
  includedFields?: string[];
  where?: string;
  callback?: (data: any) => void;
}) {
  delete socketCallbacks[widgetId];
  socketCallbacks[widgetId] = callback;
  console.log("subscribing to table", widgetId);
  await socket?.emit("subscribeToTable", {
    widgetId,
    includedFields,
    tableId,
    where,
  });
}

async function unsubscribeFromTable({
  widgetId,
  tableId,
  where,
}: {
  widgetId: string;
  tableId: string;
  where?: string;
}) {
  delete socketCallbacks[widgetId];
  await socket?.emit("unsubscribeFromTable", { widgetId, tableId, where });
}

function useSubscribeToTable({
  widgetId,
  tableId,
  includedFields,
  lastModifiedDate,
  intervalDurationInMilliseconds,
  where,
  callback,
  onSocketError,
  onSocketConnect,
}: {
  widgetId: string;
  tableId: TableName;
  includedFields?: string[];
  lastModifiedDate: string;
  intervalDurationInMilliseconds: number;
  where?: string;
  callback?: (data: any) => void;
  onSocketError?: () => void;
  onSocketConnect?: () => void;
}) {
  useEffect(() => {
    const handleError = () => {
      console.log("socket disconnected", widgetId);
      onSocketError?.();
    };

    const handleConnect = () => {
      console.log("socket connected", widgetId);
      onSocketConnect?.();
      subscribeToTable({ widgetId, tableId, includedFields, where, callback });
    };

    subscribeToTable({ widgetId, tableId, includedFields, where, callback });

    socket?.on("disconnect", handleError);
    socket?.on("error", handleError);
    socket?.on("connect_error", handleError);
    socket?.on("connect", handleConnect);

    return () => {
      unsubscribeFromTable({ widgetId, tableId, where });
      socket?.off("disconnect", handleError);
      socket?.off("connect", handleConnect);
      socket?.off("error", handleError);
      socket?.off("connect_error", handleError);
    };
  }, []);
}

function useSubscribeToTableWithPolls({
  widgetId,
  tableId,
  intervalDurationInMilliseconds,
  lastModifiedDate,
  includedFields,
  where,
  callback,
  onSocketError,
  onSocketConnect,
}: {
  widgetId: string;
  tableId: TableName;
  intervalDurationInMilliseconds: number;
  lastModifiedDate: string;
  includedFields?: string[];
  where?: string;
  callback?: (data: any) => void;
  onSocketError?: () => void;
  onSocketConnect?: () => void;
}) {
  useEffect(() => {
    let interval = setInterval(async () => {
      try {
        let result = await apiFetch("general", "checkIfNewDataAvailable", {
          tableName: tableId,
          whereStr: where,
          lastModifiedDate: lastModifiedDate,
        });
        onSocketConnect?.();
        if (result === true) {
          callback?.(null);
        }
      } catch (e) {
        onSocketError?.();
      }
    }, intervalDurationInMilliseconds || 10000);

    return () => {
      clearInterval(interval);
    };
  }, [lastModifiedDate, tableId, where]);
}

export { useSubscribeToTable, useSubscribeToTableWithPolls };
